<template>
  <div class="main-card mb-3 card">
    <div class="card-header">More</div>
    <div class="card-body">
      <div class="position-relative mb-0 form-group w-100">
        <div class="col-12 p-0">
          <label class="col-12 mb-0 p-0">Timezone</label>
          <div class="col-6 pl-0 pr-1 mt-2">
            <Select :options="Intl.supportedValuesOf('timeZone')" placeholder="Timezone" data-title="Timezone" class="has-tip p-0" :value="values?.timezone" @changeValue="store.commit('values.general.timezone', $event)"></Select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  computed: {
    storeId() {
      return 'main'
    },
    values() {
      return this.store.getter('values.general')
    }
  },
  methods: {
    handleClickSave() {
      this.$emit('submitSetting')
    }
  }
}
</script>
